<template>
  <div class="container-fluid init">
    <section id="proyecto-gestion-credito" class="my-5">
      <div class="row">
        <!-- Col Izquierda: Galería + Toast + Módulos -->
        <div class="col-lg-3 col-12 d-flex flex-column align-items-center order-lg-1 order-2 mt-3 mt-lg-0">
          <PhotoGalleryModal :images="galeria" />

          <!-- Toast de aviso -->
          <div
            class="toast align-items-center text-bg-warning border-0 show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style="max-width: 100%; color: white; margin-top: 15px;"
          >
            <div class="d-flex">
              <div class="toast-body">
                <i class="fa-solid fa-circle-exclamation"></i>
                Las capturas del <strong>sistema mostrado son reales</strong>, pero la información utilizada es
                <strong>ficticia</strong>. Los datos reales de clientes están <strong>protegidos</strong>.
              </div>
              <button
                type="button"
                class="btn-close btn-close-white me-2 m-auto"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
          </div>

          <div class="card border-0 shadow-sm rounded-2 mt-3 w-100">
            <div class="row g-3 small d-flex p-3 flex-column align-items-center">
              <h5 class="mb-2">Módulos Desarrollados</h5>
              <img
                src="/img/proyectos/gestioncreditos/6.png"
                alt="Módulos del Sistema"
                style="height:600px; width: auto;"
                class="img-fluid mb-3 rounded-1 shadow-sm"
              />
            </div>
          </div>
        </div>

        <!-- Col Centro: Article con DISEÑO tipo Ecommerce -->
        <div class="col-12 col-lg-8 order-1 order-lg-2">
          <article id="sistema-creditos" class="card border-0 shadow-sm rounded-3 case">
            <div class="card-body p-4 p-lg-5">
              <!-- Badges -->
              <div class="text-center mb-4">
                <!-- <span class="badge rounded-pill bg-soft me-2">Caso de estudio</span> -->
                <!-- <span class="badge rounded-pill bg-brand"></span> -->
                <span class="badge rounded-pill text-bg-primary">Finanzas & Créditos</span>

              </div>

              <!-- Título -->
              <h1 class="h3 mb-3 display-6 text-center">
                Sistema Financiero para Gestión de Créditos
              </h1>

              <!-- Subtítulo / lead -->
              <p class="lead text-center mb-4 text-muted">
                Plataforma en producción que administra el ciclo completo del crédito:
                solicitudes, validación, aprobación, desembolso y <em>follow-up</em> operativo; con
                API REST en Go, frontend Vue.js y base de datos PostgreSQL.
              </p>

              <!-- Hero image -->
              <div class="mb-4">
                <img
                  src="img/proyectos/gestioncreditos/20p.png"
                  alt="Vista general del sistema"
                  class="img-fluid mb-3 rounded-2 shadow-sm"
                />
              </div>

              <!-- Grilla de highlights (similar al ecommerce) -->
              <div class="row g-3 mb-4">
                <div class="col-12 col-md-6">
                  <div class="p-3 rounded-2 border bg-tint">
                    <strong><i class="fa-solid fa-diagram-project me-2"></i>Backend (API REST)</strong>
                    <p class="mb-0 small">
                      Go (Golang) con control de acceso por roles, autenticación basada en tokens,
                      endpoints para créditos, pagos, bitácora y reportes. PostgreSQL con consultas optimizadas.
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="p-3 rounded-2 border bg-tint d-flex justify-content-center flex-column " style="height: 100%;">
                    <strong><i class="fa-solid fa-window-maximize me-2"></i>Frontend (Vue.js)</strong>
                    <p class="mb-0 small">
                      SPA con Vue Router, Pinia para estado, UI responsive (Bootstrap 5) y formularios validados.
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="p-3 rounded-2 border bg-tint">
                    <strong><i class="fa-solid fa-server me-2"></i>Infraestructura</strong>
                    <p class="mb-0 small">
                      Linux + Nginx (proxy inverso), despliegue con Git, tareas programadas y <em>backups</em> automáticos.
                    </p>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="p-3 rounded-2 border bg-tint">
                    <strong><i class="fa-solid fa-gauge-high me-2"></i>Performance</strong>
                    <p class="mb-0 small">
                      Lazy loading, code splitting y paginación para listas grandes de créditos y pagos.
                    </p>
                  </div>
                </div>
              </div>

              <hr class="my-4">

              <!-- Descripción General -->
              <section class="mb-4">
                <h2 class="h5 mb-3"><i class="fa-solid fa-circle-info me-2"></i>Descripción general</h2>
                <p class="mb-0">
                  Desarrollado con metodologías ágiles y arquitectura cliente–servidor (API REST + interfaz web), el
                  sistema optimiza procesos internos de entidades financieras y potencia la toma de decisiones con
                  indicadores clave. Incluye trazabilidad mediante bitácora, control granular de permisos y seguridad de sesiones.
                </p>
              </section>

              <!-- Arquitectura técnica -->
              <div class="row g-3">
                <div class="col-12 col-lg-6">
                  <div class="card h-100 shadow-sm border-0 subcard">
                    <div class="card-body">
                      <h3 class="h6 text-uppercase text-muted mb-3">
                        <i class="fa-solid fa-sitemap me-2"></i>Arquitectura técnica
                      </h3>

                      <h6 class="text-muted mt-2 mb-1">Backend (API REST)</h6>
                      <ul class="mb-3 small">
                        <li><strong>Go (Golang)</strong> + JWT/roles.</li>
                        <li><strong>PostgreSQL</strong> con índices y funciones avanzadas.</li>
                        <li>Servicios: CRUD de créditos, bitácora, cálculos y reportes.</li>
                      </ul>

                      <h6 class="text-muted mt-2 mb-1">Frontend</h6>
                      <ul class="mb-0 small">
                        <li><strong>Vue.js (SPA)</strong> con Vue Router.</li>
                        <li>Estado con <strong>Pinia</strong>; UI con Bootstrap 5 + CSS personalizado.</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Funcionalidades clave -->
                <div class="col-12 col-lg-6">
                  <div class="card h-100 shadow-sm border-0 subcard">
                    <div class="card-body">
                      <h3 class="h6 text-uppercase text-muted mb-3">
                        <i class="fa-solid fa-list-check me-2"></i>Funcionalidades clave
                      </h3>
                      <ol class="mb-0 small">
                        <li><strong>Gestión integral</strong> del ciclo de vida del crédito.</li>
                        <li><strong>Validaciones</strong> automáticas para calidad de datos.</li>
                        <li><strong>Cálculos</strong> de intereses (corriente/moratorio), capital y mora.</li>
                        <li><strong>Reportes/KPIs</strong>: cartera, mora, recuperación y rendimientos.</li>
                        <li><strong>Bitácora</strong> filtrable por usuario y fechas.</li>
                        <li><strong>Permisos</strong> granulares y registro de acciones.</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Beneficios -->
              <section class="mt-3">
                <div class="card h-100 shadow-sm border-0 subcard">
                  <div class="card-body">
                    <h3 class="h6 text-uppercase text-muted mb-3">
                      <i class="fa-solid fa-chart-line me-2"></i>Beneficios
                    </h3>
                    <div class="row">
                      <div class="col-md-6">
                        <ul class="mb-3 small">
                          <li><strong>Eficiencia</strong> operativa (cálculos y reportes automáticos).</li>
                          <li><strong>Transparencia</strong> y control (trazabilidad completa).</li>
                          <li><strong>Decisiones</strong> estratégicas con KPIs.</li>
                        </ul>
                      </div>
                      <div class="col-md-6">
                        <ul class="mb-0 small">
                          <li><strong>Escalabilidad</strong> en usuarios y volumen.</li>
                          <li><strong>UX ágil</strong>: interfaz moderna y responsive.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <!-- Seguridad (alert) -->
              <div class="alert alert-secondary d-flex align-items-start mt-4" role="alert">
                <i class="fa-solid fa-shield-halved me-2 mt-1"></i>
                <div>
                  <strong>Seguridad:</strong> autenticación por tokens y control de permisos en cada petición.
                  Bitácora centraliza auditoría de acciones por usuario.
                </div>
              </div>

              <!-- Estado actual & Roadmap -->
              <section class="mt-3">
                <div class="card h-100 shadow-sm border-0 subcard">
                  <div class="card-body">
                    <h3 class="h6 text-uppercase text-muted mb-3">
                      <i class="fa-solid fa-rocket me-2"></i>Estado actual & Roadmap
                    </h3>
                    <ul class="mb-2 small">
                      <li><strong>En producción</strong> y en uso activo.</li>
                      <li>Herramienta clave para gestión y control de cartera.</li>
                    </ul>
                    <h6 class="text-muted mt-3 mb-2">Próximos módulos</h6>
                    <ul class="mb-0 small">
                      <li>Originación 100% digital y firma electrónica.</li>
                      <li>Integración con burós y notificaciones (email/SMS/WhatsApp).</li>
                      <li>Paneles de riesgo y alertas tempranas.</li>
                    </ul>
                  </div>
                </div>
              </section>

              <!-- Tech badges -->
              <div class="d-flex flex-wrap gap-2 mt-4">
                <span class="badge tech-badge">Go (Golang)</span>
                <span class="badge tech-badge">PostgreSQL</span>
                <span class="badge tech-badge">Vue 3</span>
                <span class="badge tech-badge">Pinia</span>
                <span class="badge tech-badge">Bootstrap 5</span>
                <span class="badge tech-badge">JWT</span>
                <span class="badge tech-badge">Linux</span>
                <span class="badge tech-badge">Nginx</span>
                <span class="badge tech-badge">Git</span>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PhotoGalleryModal from '../../PhotoGalleryModal.vue'

export default {
  name: 'ahdecoStatic',
  components: {
    PhotoGalleryModal
  },
  data() {
    return {
      galeria: []
    }
  },
  beforeMount() {
    const rutas = [];

    // Primero del 8 al 32
    for (let i = 8; i <= 32; i++) {
      rutas.push(`/img/proyectos/gestioncreditos/${i}.png`);
    }

    // Luego del 1 al 7
    for (let i = 1; i <= 7; i++) {
      rutas.push(`/img/proyectos/gestioncreditos/${i}.png`);
    }

    this.galeria = rutas;
  },
}
</script>

<style scoped>
/* Espaciado superior general del bloque */
.init { margin-top: 150px; }

/* === Tema y “look & feel” tipo ecommerce === */
:root {
  --bg-card: #ffffff;
  --bg-soft: rgba(15, 23, 42, 0.04);
  --border-soft: rgba(2, 6, 23, 0.08);
  --text: #1a1f29;
  --muted: #445063;
  --brand: #2f6bff;
  --brand-2: #7a35ff;
  --shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
  --radius: 14px;
  --grad:
    radial-gradient(1200px 600px at 10% -10%, rgba(47,107,255,.12), transparent 60%),
    radial-gradient(800px 400px at 90% -20%, rgba(122,53,255,.10), transparent 60%);
}

/* Respeta dark mode del SO */
@media (prefers-color-scheme: dark) {
  :root {
    --bg-card: #151a20;
    --bg-soft: rgba(255, 255, 255, 0.05);
    --border-soft: rgba(255, 255, 255, 0.10);
    --text: #e6e9ef;
    --muted: #b4bccb;
    --brand: #6ea8fe;
    --brand-2: #8a5cff;
    --shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  }
}

/* Card principal con gradiente sutil */
.case {
  position: relative;
  background-color: #ffffff !important; /* Fondo blanco fijo */
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  border: 1px solid var(--border-soft);
  overflow: hidden;
}

/* Subcards internas “soft” */
.subcard {
  background: var(--bg-card);
  border-radius: 12px;
}

/* Badges suaves */
.bg-soft {
  background: var(--bg-soft);
  color: var(--muted);
  border: 1px solid var(--border-soft);
}
.bg-brand {
  background: linear-gradient(90deg, var(--brand), var(--brand-2));
  color: #fff;
  border: 0;
}

/* Paneles “tint” dentro del grid de highlights */
.bg-tint {
  background: var(--bg-soft);
  border-color: var(--border-soft);
}

/* Badges de tecnologías */
.tech-badge {
  background: var(--bg-soft);
  color: var(--text);
  border: 1px solid var(--border-soft);
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
}

/* Tipografía y colores */
h1, h2, h3, h4, h5, h6 { color: var(--text); }
.lead { color: var(--muted); }
small, .text-muted { color: var(--muted) !important; }

/* Utilidades menores */
.tec { font-size: 0.8rem; }
</style>
